import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DangerString from '../../common/components/danger-string';
import {
  HiddenInviteCode,
  HiddenProduct,
  HiddenRedirect,
  HiddenReferral,
  HiddenXSRF
} from '../../common/components/forms';
import IString from '../../common/components/i-string';
import WaitButton from '../../common/components/wait-button';

function VerificationRequired(props) {
  const { email, onUpdateEmailClick, resend } = props;

  const [pending, setPending] = useState(false);

  return (
    <>
      <h2 className='formTitle'>
        <IString stringKey='required.title' />
      </h2>
      <form onSubmit={() => setPending(true)} method='post'>
        <p>
          <DangerString stringKey='required.message' placeholders={{ email }} />
        </p>
        <HiddenInviteCode />
        <HiddenProduct />
        <HiddenRedirect />
        <HiddenReferral />
        <HiddenXSRF />
        <fieldset className='actions noMarginAbove'>
          <WaitButton type='submit' wait={pending} >
            <IString stringKey='required.submit' />
          </WaitButton>
        </fieldset>
      </form>
      <div className='afterTheForm'>
        <p className='marginAbove'>
          <IString stringKey='update.wrongEmail' placeholders={{
            update: <button className='standardLink inline' type='button' onClick={onUpdateEmailClick}>
              <strong>
                <IString stringKey='update.updateEmail' />
              </strong>
            </button>
          }} />
        </p>
        <p className='marginAbove'>
          <IString stringKey='required.noEmail' placeholders={{
            resend: <button className='standardLink inline' type='button' onClick={resend}>
              <strong>
                <IString stringKey='required.resend' />
              </strong>
            </button>
          }} />
        </p>
      </div>
    </>
  );
}

VerificationRequired.propTypes = {
  email: PropTypes.string,
  onUpdateEmailClick: PropTypes.func,
  resend: PropTypes.func
};

export default VerificationRequired;
